import classNames from "classnames";
import styles from "./style.module.scss";
import { DOTS, usePagination } from "shared/hooks/usePagination";
import { Icons } from "assets";

const CustomPagination = (props: any) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className,
    displayArrow = true,
    disabled,
  } = props;

  const paginationRange: any = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
    displayArrow,
  });

  if (
    currentPage === 0 ||
    paginationRange?.length < 2 ||
    // eslint-disable-next-line
    paginationRange == undefined
  ) {
    return null;
  }

  const onNext = () => {
    if (!disabled) {
      if (currentPage < totalCount / pageSize) {
        onPageChange(currentPage + 1);
      }
    }
  };

  const onPrevious = () => {
    if (!disabled) {
      if (currentPage > 1) {
        onPageChange(currentPage - 1);
      }
    }
  };

  return (
    <ul
      className={classNames(styles.paginationContainer, "ps-0 gap-2 ", {
        [className]: className,
      })}
    >
      {displayArrow ? (
        <li
          className={classNames(styles.display, "flex-1 justify-start")}
          onClick={onPrevious}
        >
          <div
            className={classNames(
              styles.arrowContainer,
              styles.activeContainer,
              currentPage > 1 ? "flex" : "hidden"
            )}
            role={currentPage > 1 ? "button" : "none"}
          >
            <Icons.ArrowLeft
              className={classNames(
                styles.iconStyle,
                currentPage > 1 && styles.activeIcon
              )}
            />
            <label>Previous</label>
          </div>
        </li>
      ) : null}

      <div className={classNames("flex flex-1 justify-center")}>
        {paginationRange &&
          paginationRange?.map((pageNumber: any, inx: any) => {
            if (pageNumber === DOTS) {
              return (
                <li className={styles.dots} key={inx}>
                  &#8230;
                </li>
              );
            }
            return (
              <li
                className={classNames(
                  styles.paginationItem,
                  pageNumber === currentPage && styles.active
                )}
                onClick={() => onPageChange(pageNumber)}
                key={inx}
              >
                {pageNumber}
              </li>
            );
          })}
      </div>
      {displayArrow ? (
        <li
          className={classNames(styles.display, "flex-1 justify-end")}
          onClick={onNext}
        >
          <div
            className={classNames(
              styles.arrowContainer,
              styles.activeContainer,
              currentPage < totalCount / pageSize ? "flex" : "hidden"
            )}
            role={currentPage < totalCount / pageSize ? "button" : "none"}
          >
            <label>Next</label>
            <Icons.ArrowRight
              className={classNames(
                styles.iconStyle,
                currentPage < totalCount / pageSize && styles.activeIcon
              )}
            />
          </div>
        </li>
      ) : null}
      {displayArrow ? (
        <div className={classNames(" gap-3 my-3", styles.smallScreenDisplay)}>
          <li onClick={onPrevious}>
            <div
              className={classNames(
                styles.arrowContainer,
                currentPage > 1 && styles.activeContainer
              )}
              role={currentPage > 1 ? "button" : "none"}
            >
              <Icons.ArrowLeft
                className={classNames(
                  styles.iconStyle,
                  currentPage > 1 && styles.activeIcon
                )}
              />
            </div>
          </li>
          <li onClick={onNext}>
            <div
              className={classNames(
                styles.arrowContainer,
                currentPage < totalCount / pageSize && styles.activeContainer
              )}
              role={currentPage < totalCount / pageSize ? "button" : "none"}
            >
              <Icons.ArrowRight
                className={classNames(
                  styles.iconStyle,
                  currentPage < totalCount / pageSize && styles.activeIcon
                )}
              />
            </div>
          </li>
        </div>
      ) : null}
    </ul>
  );
};

export default CustomPagination;
